export const LOAD_COURSES_CHECKOUT = 'LOAD_COURSES_CHECKOUT';
export const LOAD_COURSES_CHECKOUT_SUCCESS = 'LOAD_COURSES_CHECKOUT_SUCCESS';
export const LOAD_COURSES_CHECKOUT_FAIL = 'LOAD_COURSES_CHECKOUT_FAIL';

export const UPDATE_COURSES_CHECKOUT_PRICE = 'UPDATE_COURSES_CHECKOUT_PRICE'
